import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";

import {
    EULA_PDF_URL,
    PRIVACY_POLICY_PDF_URL,
    WHATS_NEW_PAGE_URL,
} from "../constants";

import { PdfContentPopup } from "./shared/PdfContentPopup";

const useStyles = makeStyles((theme) => ({
    container: {
        padding: "8px 0 16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "28px",
        fontSize: "12px",
        color: theme.palette.text.disabled,
    },
    buttonLink: {
        background: "none",
        border: "none",
        padding: 0,
        margin: 0,
        color: theme.palette.text.disabled,
        textDecoration: "underline",
        cursor: "pointer",
        font: "inherit",
        fontSize: "12px",
        letterSpacing: "0.01em",
        transition: "color 0.15s ease",
    },
}));

export function FooterLinks() {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <Link href={WHATS_NEW_PAGE_URL} label="What's New" />

            <LinkWithPdfContentPopup
                href={PRIVACY_POLICY_PDF_URL}
                label="Privacy Policy"
            />

            <LinkWithPdfContentPopup
                href={EULA_PDF_URL}
                label="Terms and Conditions"
            />
        </div>
    );
}

function LinkWithPdfContentPopup({
    href,
    label,
}: {
    href: string;
    label: string;
}) {
    const classes = useStyles();
    const [open, setOpen] = useState(false);

    return (<>
        <button
            onClick={() => setOpen(prev => !prev)}
            className={classes.buttonLink}
        >
            {label}
        </button>

        <PdfContentPopup
            open={open}
            setOpen={setOpen}
            title={label}
            href={href}
        />
    </>);
}

function Link({
    href,
    label,
}: {
    href: string;
    label: string;
}) {
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "inherit" }}
        >
            {label}
        </a>
    );
}
